<template>
    <Path>
        <template v-slot:path>
            <li><router-link :to="{name: 'dashboard'}" >الصفحة الرئيسية</router-link> </li>
            <li> <span class="divider"> / </span><a href="#">الأخبار </a> </li>
        </template>
    </Path>

    <section>
        <div class="py-4 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2 ">

                        <h1 class="blueFont py-3"> تجهيز اسطول من الحافلات المُجهزة فنياً ولوجستياً (مراكز تكنولوجية
                            مُتنقلة) </h1>

                        <p>
                            تنفيذا لتوجيهات السيد الفاضل اللواء وزير الداخليه وموافقه سيادته على تنفيذ خطه تطوير اداء
                            القطاع والارتقاء بالخدمات المقدمه لجمهور المواطنين والتيسير عليهم لمواجهه التحديات والمعوقات
                            التى تؤثر على منظومه العمل بقطاع الاحوال المدنية وبناء على توجيهات السيد اللواء مساعد الوزير
                            لقطاع الاحوال المدنية تم تنفيذ الاتى :
                            <br>
                            تجهيز اسطول من الحافلات المُجهزة فنياً ولوجستياً (مراكز تكنولوجية مُتنقلة) يضم (85) سيارة
                            جديدة مُتنوعة المهام لتوجيها جغرافياً إلى جميع أنحاء الجمهورية لتعزيز تقديم كافة خدمات
                            القطاع بالمناطق الأولى بالرعاية المُجتمعية وكذا التى تشهد كثافات سكانية عاليه
                        </p>
                        <div class="container2">
                            <img @click="LightBox" src="@/assets/images/IdealCenters/Center04/01.jpg" alt=""
                                class=" img-fluid py-3 pointer">
                            <div class="overlay">
                                <a @click="LightBox" href="#" class="icon" title="User Profile">
                                    <i class="fas fa-play watermark"></i>
                                </a>
                            </div>


                        </div>

                        <a @click="CloseDiv">
                            <div v-if="play" id="lightbox" class="lightbox">
                                <iframe
                                    src="https://www.youtube.com/embed/kM-41E_p7ks?rel=0&modestbranding=1&autohide=1&mute=1&showinfo=0&controls=1&autoplay=1"
                                    width="560" height="315" frameborder="0" allowfullscreen>
                                </iframe>
                            </div>
                            <div v-else id="lightbox" class="lightbox">

                            </div>
                        </a>
                    </div>

                </div>
            </div>
        </div>
    </section>

</template>

<script>
import Path from '@/components/Path.vue'
export default {
    name: 'News2Comp',
    components: { Path },
    created() {
        window.scrollTo({ top: 0, behavior: "smooth" });
    },
    data() {
        return { play: true }
    },
    methods: {
        LightBox() {
            this.play = true;
            let element = document.querySelector('.lightbox');
            element.classList.add("active");

        },
        CloseDiv() {
            this.play = false;
            let element = document.querySelector('.lightbox');
            element.classList.remove("active");

        }
    }
}
</script>